document.addEventListener('DOMContentLoaded', () => {
  initMobileMenu();
  initMobileReminder();
  initHeaderScroll();
  initSlider();
  initForm();
  initAnchors();
});

// Mobile Menu Functional

function initMobileMenu() {
  const header = document.getElementById('site-header');
  const toggleBtn = document.getElementById('mobile-menu-toggle');
  const mobileMenu = document.getElementById('mobile-menu');

  if (!header || !toggleBtn || !mobileMenu) return;

  const openIcon = toggleBtn.querySelector('.menu-open');
  const closeIcon = toggleBtn.querySelector('.menu-close');

  toggleBtn.addEventListener('click', () => {
    mobileMenu.classList.toggle('hidden');
    openIcon.classList.toggle('hidden');
    closeIcon.classList.toggle('hidden');
  });

  mobileMenu.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', () => {
      mobileMenu.classList.add('hidden');
      openIcon.classList.remove('hidden');
      closeIcon.classList.add('hidden');
    });
  });
}

// Header Functional

function initHeaderScroll() {
  const header = document.getElementById('site-header');
  if (!header) return;

  window.addEventListener('scroll', () => {
    const scrolled = window.scrollY > 50;

    header.classList.toggle('bg-transparent', !scrolled);
    header.classList.toggle('py-5', !scrolled);

    header.classList.toggle('bg-navy-950/95', scrolled);
    header.classList.toggle('backdrop-blur-md', scrolled);
    header.classList.toggle('py-3', scrolled);
    header.classList.toggle('shadow-xl', scrolled);
  });
}

// Slider Functional

function initSlider() {
  const slider = document.querySelector('.testimonial-slider');
  const prev = document.querySelector('.testimonial-prev');
  const next = document.querySelector('.testimonial-next');
  const dotsContainer = document.querySelector('.testimonial-dots');

  if (!slider) return;

  const slides = slider.children;
  const dots = dotsContainer
    ? dotsContainer.querySelectorAll('[data-index]')
    : [];

  let index = 0;

  const update = () => {
    slider.style.transform = `translateX(-${index * 100}%)`;

    if (!dots.length) return;

    dots.forEach((dot, i) => {
      dot.classList.toggle('w-12', i === index);
      dot.classList.toggle('bg-military-gold', i === index);
      dot.classList.toggle('w-2', i !== index);
      dot.classList.toggle('bg-white/20', i !== index);
    });
  };

  if (next) {
    next.addEventListener('click', () => {
      index = (index + 1) % slides.length;
      update();
    });
  }

  if (prev) {
    prev.addEventListener('click', () => {
      index = (index - 1 + slides.length) % slides.length;
      update();
    });
  }

  dots.forEach(dot => {
    dot.addEventListener('click', () => {
      index = parseInt(dot.dataset.index, 10);
      update();
    });
  });

  update();
}

// Mobile Reminder

function initMobileReminder() {
  const reminder = document.getElementById("appReminder");
  if (!reminder) return;

  const iosLink = document.getElementById("app-link-ios");
  const androidLink = document.getElementById("app-link-android");
  const closeBtn = reminder.querySelector("button");

  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  const isIOS = /iPad|iPhone|iPod/.test(userAgent);
  const isAndroid = /android/i.test(userAgent);

  if (isIOS) {
    if (iosLink) {
      iosLink.classList.remove("hidden");
    } else {
      reminder.style.display = "none";
      return;
    }
  }

  else if (isAndroid) {
    if (androidLink) {
      androidLink.classList.remove("hidden");
    } else {
      reminder.style.display = "none";
      return;
    }
  }

  else {
    reminder.style.display = "none";
    return;
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", () => {
      reminder.style.display = "none";
    });
  }
}

// Form Functional

function initForm() {
	const form = document.getElementById('consult-form');
	const formContent = document.getElementById('form-content');
	const success = document.getElementById('consult-success');
	const reset = document.getElementById('consult-reset');

	if (!form) return;

	const nameInput = form.querySelector('input[type="text"]');
  const phoneInput = form.querySelector('input[type="tel"]');
  const textInput = form.querySelector('textarea');

  phoneInput.value = '+380 ';

  function formatPhone(value) {
    let digits = value.replace(/\D/g, '');

    if (digits.startsWith('380')) {
      digits = digits.slice(3);
    }

    digits = digits.substring(0, 9);

    let result = '+380 ';

    if (digits.length > 0) {
      result += '(' + digits.substring(0, 2);
    }

    if (digits.length >= 2) {
      result += ') ' + digits.substring(2, 5);
    }
    
    if (digits.length >= 5) {
      result += '-' + digits.substring(5, 9);
    }

    return result;
  }

  phoneInput.addEventListener('input', function () {
    this.value = formatPhone(this.value);
  });

  phoneInput.addEventListener('keydown', function (e) {
    const isDelete = e.key === 'Backspace' || e.key === 'Delete';

    if (!isDelete) return;

    const digits = this.value.replace(/\D/g, '');

    if (
      this.selectionStart === 0 &&
      this.selectionEnd === this.value.length
    ) {
      e.preventDefault();
      this.value = '+380 ';
      return;
    }

    if (this.selectionStart <= 4) {
      e.preventDefault();
      return;
    }

    e.preventDefault();

    let clean = digits.startsWith('380')
      ? digits.slice(3)
      : digits;

    clean = clean.slice(0, -1);

    this.value = formatPhone('+380' + clean);
  });

	const isValidName = v =>
		/^[a-zA-Zа-яА-ЯіІїЇєЄґҐ\s'-]{2,}$/.test(v.trim());

	const isValidPhone = v => {
    const clean = v.replace(/\D/g, '');
    return /^380\d{9}$/.test(clean);
  };

	const isValidText = v =>
		v.trim().length >= 2;

	form.addEventListener('submit', async e => {
		e.preventDefault();

		let valid = true;

		[nameInput, phoneInput, textInput].forEach(el =>
			el.classList.remove('!border-red-500')
		);

		if (!isValidName(nameInput.value)) {
			nameInput.classList.add('!border-red-500');
			valid = false;
		}

		if (!isValidPhone(phoneInput.value)) {
			phoneInput.classList.add('!border-red-500');
			valid = false;
		}

		if (!isValidText(textInput.value)) {
			textInput.classList.add('!border-red-500');
			valid = false;
		}

		if (!valid) return;

    const pageUrl = window.location.href;
    
    const cleanPhone = phoneInput.value.replace(/\D/g, '');

		const formData = new URLSearchParams({
      action: 'send_to_crm',
      client_name: nameInput.value,
      client_phone: cleanPhone,
      description: textInput.value + "\n\nСторінка: " + pageUrl
    });

		try {
			const response = await fetch(myAjax.ajaxurl, {
				method: 'POST',
				headers: {
					'Content-Type':
						'application/x-www-form-urlencoded;charset=UTF-8'
				},
				body: formData
			});

			const result = await response.json();

			if (result.success) {
				form.style.display = 'none';
				formContent?.style && (formContent.style.display = 'none');
				success.classList.remove('hidden');
			} else {
				alert('Помилка відправки');
			}

		} catch (err) {
			alert('Помилка зʼєднання');
			console.error(err);
		}
	});

	reset?.addEventListener('click', () => {
		form.reset();
		form.style.display = 'block';
		formContent.style.display = 'block';
		success.classList.add('hidden');

		[nameInput, phoneInput, textInput].forEach(el =>
			el.classList.remove('!border-red-500')
		);
	});
}

function initAnchors() {
  document.addEventListener('click', e => {
    const link = e.target.closest('a[href^="#"]');
    if (!link) return;

    const targetId = link.getAttribute('href');
    if (!targetId || targetId === '#') return;

    const target = document.querySelector(targetId);
    if (!target) return;

    e.preventDefault();

    const header = document.querySelector('header');
    const offset = header ? header.offsetHeight : 80;
    const top = target.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
      top,
      behavior: 'smooth'
    });
  });
}